import axios from '../../config/axios';

export const paymentsApi = {
  getElectronicPayments: async (params = {}) => {
    try {
      const response = await axios({
        method: 'get',
        url: '/api/admin/payments',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        params: {
          ...params
          // مش محتاج type عشان نجيب كل المدفوعات
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getPaymentDetails: async (id) => {
    try {
      const response = await axios({
        method: 'get',
        url: `/api/admin/payments/${id}`,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
